import React, { FC, ReactElement, useState, useEffect } from 'react';
import { getEventKey } from '../../../stores/reducers/userData';
import { useSelector } from 'react-redux';
import './cookieAccept.sass';
import {storageFactory} from '../../../helpers/storage';
const storage = storageFactory(() => localStorage);

const CookieAccept: FC = (): ReactElement => {
  const [isCookieAccepted, setIsCookieAccepted] = useState<boolean>(false);
  const eventKey = useSelector(getEventKey);

  const acceptCookie = (): void => {
    storage.setItem(`_ca-${eventKey}`, '1');
    setIsCookieAccepted(true);
  };

  useEffect(() => {
    const isAccepted = storage.getItem(`_ca-${eventKey}`);
    if (isAccepted) {
      acceptCookie();
    } else {
      setIsCookieAccepted(false);
    }
  }, [eventKey, isCookieAccepted]);

  return ( !isCookieAccepted ?
    <div className="cookie-accept">
      <div className="cookie-accept__wrapper">
        <div className="cookie-accept__content">
          <p>
            Мы используем файлы «Cookie» для сбора и анализа информации о
            производительности и использовании сайта, а также для улучшения и индивидуальной
            настройки предоставления информации. Нажимая кнопку «ОК» или продолжая
            пользоваться данным сайтом, вы соглашаетесь на обработку файлов «Cookie».&nbsp;
            <a href="https://www.comdi.com/upload/cookie_policy.pdf" target="_blank" rel="noopener noreferrer">Прочитать об этом</a>
          </p>
        </div>
        <button className="btn btn--mobile-min" onClick={() => acceptCookie()}>OK</button>
      </div>
    </div>
    :
    <></>
  );
}

export default CookieAccept;
